import { useDispatch, useSelector } from 'react-redux'
import { Checkbox } from '../../../../../common/html/checkbox'
import { changeDetailsSuggest, selectSuggest } from '../../store/slice'

export const CustomThCheckBox = ({ val }) => {
  const dispatch = useDispatch()

  const data = useSelector(selectSuggest())
  const checked = Object.values(data).every((item) => item?.check)

  // Actions
  const handleCheck = () => {
    const dataFormat = {}
    Object.keys(data).forEach((item) => {
      dataFormat[item] = { ...data[item], check: !checked }
    })

    dispatch(
      changeDetailsSuggest({
        path: ['dataDetailsSuggest'],
        data: dataFormat,
      }),
    )
  }

  return (
    <>
      <Checkbox
        title={val}
        isI18n
        isCheckOnClickText
        checked={checked}
        onChange={handleCheck}
        style={{ textTransform: 'capitalize' }}
      />
    </>
  )
}
